<template>
    <div class="o-search-panel-otg">
        <!-- <div class="o-search-panel-otg__back-panel">
            <AIconButton
                :text="$t('ui.back')"
                icon="arrow-left-otg-green"
                :class="`back-button ${from.path == '/' ? 'disabled' : ''}`"
                @onClick="onClickBack"
            />
            <AIconButton
                icon="close-otg-black"
                class="close-button"
                @onClick="onClickClose"
            />
        </div> -->
        <header class="search-panel-otg-header">
            <h3 class="search-panel-otg-title">
                {{ $t('ui.find-out-at-the-center') }}
            </h3>
        </header>
        <section class="search-panel-otg-input-wrapper">
            <AInput
                v-model="searchValue"
                :placeholder="$t('ui.Search')"
                class="search-panel-otg-input"
                @input="onInput"
            />
            <span
                v-if="!searchResults.length"
                class="no-results"
            >
                {{ $t('ui.no-results-text') }}
            </span>
        </section>
        <OItemsSortingOtg
            v-if="isSortingPanel"
            v-model="letter"
            :items="sortingLetters"
            class="sorting-panel-otg"
        />
        <div class="searchbar-items-container">
            <OSearchbarItemOtg
                v-for="(item, index) in searchResults"
                :key="index"
                :id="item.id || item.item.id"
                :title="item.name || item.item.name"
                :floor="item.floor || item.item.floor"
                @onClick="onItemClick"
            />
        </div>
    </div>
</template>

<script>
import Fuse from "fuse.js";
import { mapGetters } from "vuex";

import AInput from '../../atoms/a-input/a-input';
// import AIconButton from '../../atoms/a-icon-button';
import OItemsSortingOtg from '../../organisms/o-items-sorting-otg';
import OSearchbarItemOtg from '../../organisms/o-searchbar-item-otg';

import {WEB_INTEGRATION} from "@/utils/constants/route-constants";
import {routerPushHandler} from "@/utils/helpers/common";

export default {
    name: 'OSearchPanelOtg',
    components: {
        AInput,
        // AIconButton,
        OItemsSortingOtg,
        OSearchbarItemOtg
    },
    data() {
        return {
            searchValue: '',
            letter: '',
            from: null
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getTenantsAZ'
        ]),
        sortingLetters() {
            const items = [...this.getTenantsAZ];
            const letters = [];

            items.forEach(el => {
                const name = this.t(el, 'name');
                letters.push(name.charAt(0).toLowerCase())
            })

            return [...new Set(letters)];
        },
        filteredItems() {
            const items = [...this.getTenantsAZ];

            if (!this.letter) return this.prepareItems(items);

            return this.prepareItems(items.filter(el => {
                const name = this.t(el, 'name');

                return name.charAt(0).toUpperCase() === this.letter.toUpperCase()
            }))
        },
        fuseSearchKeys() {
            return [{
                name: 'name',
                weight: 3
            }, {
                name: 'alt_names',
                weight: 2
            }, {
                name: 'content',
                weight: 0.5
            }, {
                name: 'short_description',
                weight: 1
            }];
        },
        fuseOptions() {
            return {
                keys: this.fuseSearchKeys,
                findAllMatches: true
            }
        },
        searchResults() {
            return this.searchValue ?
                (new Fuse(this.filteredItems, this.fuseOptions)).search(this.searchValue)
                : this.filteredItems;
        },
        isSortingPanel() {
            return Boolean(!this.searchValue);
        },
        isStore() {
            return this.$route.name.includes(WEB_INTEGRATION.STORE.ROOT.NAME)
        }
    },
    methods: {
        onItemClick(id) {
            this.$router.push({name: WEB_INTEGRATION.CATALOGUE.START.NAME, query: { ...this.$route.query, mTo: id, mv: 'LevelView' } });
        },
        prepareItems(items) {
            return items.map(item => {
                return {
                    id: item.id,
                    name: this.t(item, 'name'),
                    floor: this.t(item.floor, 'name'),
                    alt_names: this.t(item, 'alt_names'),
                    content: this.t(item, 'content'),
                    short_description: this.t(item, 'short_description')
                }
            })
                .filter(({name}) => name)
        },
        onInput() {
            this.letter = '';
        },
        routerPushChanges(newRouteProps){
            const currentRoute = this.$route;
            const newRoute = _.merge({}, currentRoute, newRouteProps);
            !_.isEqual(currentRoute, newRoute) && this.$router.push(newRoute);

        }
    },
    mounted() {
        const adjustedRoute = {query: { mv: 'OutdoorView' }};
        this.routerPushChanges(adjustedRoute);
        //this.$router.push({query: { ...this.$route.query, mv: 'OutdoorView' }});
    },
}
</script>

<style lang="scss" src="./theme.scss" />
